import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {IYear} from '../../../models/IYearModel';
import {IStates} from '../../../models/IStatesModel';

declare var moment: any;

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor(private http: HttpClient) {
  }

  getCommodities(year: number, stateCode: string) {
    return this.http.get(`${environment.api_url}/public/commodities/pricediscovery/${year}/${this.minTwoDigitsForState(stateCode)}`);
  }

  getPriceHistory(commodityCode: string, reinsuranceYear: number, stateCode: string) {
    const uri = `${environment.api_url}/public/market/getHistory?marketSymbol=${commodityCode}&stateCode=${stateCode}&currentYear=${reinsuranceYear}`;
    return this.http.get(uri);
  }

  getTableData(
    actuarialDate: number,
    commodityCode: string,
    commodityYear: number,
    practiceCode: number,
    stateCode: string,
    typeCode: number,
    timeFrame: string) {
    const body = {
      actuarialDate,
      commodityCode,
      commodityYear,
      practiceCode,
      stateCode,
      typeCode
    };
    switch (timeFrame) {
      case 'projected':
        return this.http.post(`${environment.api_url}/public/prices/projectedPrice`, body);
      case 'harvest':
        return this.http.post(`${environment.api_url}/public/prices/harvestPrice`, body);
      default:
        return this.http.post(`${environment.api_url}/public/prices/tableData`, body);
    }
  }

  getYearsHistorical(params: any, stateCode: number) {
    let Params = new HttpParams();
    Object.keys(params).forEach((key) => {
      Params = Params.append(key, params[key]);
    });
    return this.http.get(
      `${environment.fmh_webService}/admapiweb/PriceDiscovery/state/StateCode/${this.minTwoDigitsForState(stateCode)}`,
      {params: Params});
  }

  minTwoDigitsForState(n: number | string) {
    if (typeof n === 'string') {
      n = parseInt(n, 10);
    }
    return (n < 10 ? '0' : '') + n;
  }
}
